<shared-ui-inputs-input-group
  [customInput]="phoneTemplate"
  [appendElements]="appendElements"
  [prependElements]="prependElements"
  [tabIndex]="tabIndex"
  [parentFormGroup]="parentFormGroup"
  [display]="display"
  [labelColumns]="labelColumns"
  [formName]="formName"
  [name]="name"
>
  <ng-template #phoneTemplate>
    <input pInputText #phoneInput type="tel" [tabIndex]="tabIndex" pSize="small" class="w-100" />
    <span *ngIf="!isNumberValid() && control.dirty && iti?.getNumber()" class="invalid-feedback d-block"> Invalid phone number. </span>
  </ng-template>
</shared-ui-inputs-input-group>
